import { render, staticRenderFns } from "./ManualConfig.vue?vue&type=template&id=01c207ac&"
import script from "./ManualConfig.vue?vue&type=script&lang=js&"
export * from "./ManualConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports